module.exports = {
    LoginSuccess:"Login Successful",
    LoginAuthTimeOver:"Login Authorization Timeout",
    LoginAuthFail:"Login Authorization Failed",
    LoginNotUser:"Account does not exist!",
    LoginNot:"Not logged in",
    LoginOK:"Login OK",
    LoginFail:"Login Fail",
    SendCodeOK:"The verification code has been sent to your mobile phone ({mobile})",
    SendCodeFail:"Verification code sending failed",
    ErrorRequestParameter:"Parameter error",
    LoginCodeOverTime:"Login verification code expired",
    LoginCodeError:"Verification code error",
    LoginPasswordError:'Login account or password error',
   LoginAccountDisabled:'Login account is disabled',
   LoginAccountLocked:' Login account is locked'
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/login.js